import { type ReactElement, type ReactNode, useState, useEffect } from "react"
import ProfileManager from "./ProfileManager"
import { AppDispatch } from "src/app/store"
import { Link, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { RootState } from "src/app/store"
import { DealerType } from "src/features/admin/types/DealerType"
import dsxImage from "../assests/images/dsx.png"
import { getDealers } from "src/features/admin/hooks/dealers"
import { getDealerById } from "src/features/admin/hooks/dealer"
import Spinner from "./Spinner"

export interface NavbarProps {
        headerType: string;
        dealerId?: string;
}

export default function Navbar(props: NavbarProps): ReactElement {
        const dispatch = useDispatch<AppDispatch>();
        const [title, setTitle] = useState<string>("");
        const { dealerLoading, dealer } = useSelector((state: RootState) => state.dealer);
        const { authUser } = useSelector((state: RootState) => state.auth);

        useEffect(() => {
                if (props.headerType === "admin") {
                        setTitle("DSX Administrator");
                }
                else if (props.headerType === "dealer") {
                        dispatch(getDealerById(props.dealerId));
                }
                else if (props.headerType === "dashboard") {
                        setTitle("Dashboard");
                }
                else if (props.headerType === "order") {
                        setTitle("Order Management");
                }
                else if (props.headerType === "search") {
                        setTitle("Search");
                }
                else if (props.headerType === "user") {
                        setTitle("User Management");
                }
        }, [props.headerType])

        return <>
                {dealerLoading ?
                        <Spinner title="Loading" />
                        :
                        <div className="bg-blue-700 rounded-xs shadow-[4px_4px_10px_rgba(0,0,0,0.25)] place-content-between w-full flex gap-4 p-2">
                                <div className="flex align-middle justify-center items-center gap-4">
                                        {props.headerType === "dealer" ?
                                                <div className="flex items-center text-2xl text-white font-bold">{dealer.Name}</div>
                                                :
                                                <div className="flex items-center text-2xl text-white font-bold">{title}</div>
                                        }
                                </div>
                                <div>
                                        <ProfileManager user={authUser} />
                                </div>
                        </div>
                }
        </>
}
